(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.formTips = {
    attach: function (context, settings) {
      once('formTips', '.node-form', context).forEach(function (block) {
        // Add tooltips

        let $form = $(block);
        if($form.is('.node-adjudicator-form, .node-company-form')) {
          $form.find('.form-item').each(function (i) {
            $formitem = $(this);
            if($formitem.find('.description').length > 0 && !$formitem.is('.form-item-field-company-gdpr-value, .form-item-field-adjudicator-condition-value')) {
              $formitem.addClass('has-tip');
              $formitem.find('label, .field-label h4').append('<span class="tip inline-block -mt-1 ml-2" role="tooltip"><svg xmlns="http://www.w3.org/2000/svg" class=" w-5 h-5 inline-block" viewBox="0 0 14.886 14.886">\n' +
                '  <path id="Tracé_87" data-name="Tracé 87" d="M7.443,0a7.443,7.443,0,1,0,7.443,7.443A7.443,7.443,0,0,0,7.443,0ZM8.992,11.535q-.575.227-.917.345a2.419,2.419,0,0,1-.8.119A1.585,1.585,0,0,1,6.2,11.66a1.1,1.1,0,0,1-.385-.861,3.129,3.129,0,0,1,.028-.415c.02-.141.05-.3.093-.478l.48-1.694c.042-.163.079-.317.108-.461a2.042,2.042,0,0,0,.043-.4A.614.614,0,0,0,6.431,6.9a.759.759,0,0,0-.512-.127,1.344,1.344,0,0,0-.381.057c-.129.04-.241.076-.333.111l.127-.522q.471-.192.9-.328a2.662,2.662,0,0,1,.813-.137,1.555,1.555,0,0,1,1.066.334,1.11,1.11,0,0,1,.374.867q0,.111-.026.389a2.6,2.6,0,0,1-.1.511L7.886,9.743c-.039.135-.074.29-.105.464a2.452,2.452,0,0,0-.046.394.567.567,0,0,0,.151.459.843.843,0,0,0,.521.122,1.512,1.512,0,0,0,.394-.061,2.243,2.243,0,0,0,.319-.107ZM8.908,4.681a1.138,1.138,0,0,1-.8.31,1.15,1.15,0,0,1-.807-.31.99.99,0,0,1-.336-.752A1,1,0,0,1,7.3,3.176,1.142,1.142,0,0,1,8.1,2.863a1.129,1.129,0,0,1,.8.313,1.015,1.015,0,0,1,0,1.505Z" fill="#1a00c6"/>\n' +
                '</svg>\n<div class="tooltip-arrow" data-popper-arrow></div></span>');
            }
            if($formitem.is('.form-item-field-company-gdpr-value, .form-item-field-adjudicator-condition-value')) {
              let desc = $formitem.find('.description').html();
              $formitem.find('label').html(desc);
            }
          })
        }

        const tooltips = document.querySelectorAll('.has-tip');

        tooltips.forEach(tooltip => {
          const button = tooltip.querySelector('.tip');
          const content = tooltip.querySelector('.description').textContent;
          tippy(button, {
            content: content,
            theme: 'tomato',
          });
        });

        // Customize add more buttons
        $('.field-add-more-submit').addClass('is-secondary');

        // Reduce select size for NACE

        /*var maxLength = 40;
        $('.shs-enabled.form-select option').text(function(i, text) {
          $(this).attr('title', text);
          console.log(text.length > maxLength);
          if (text.length > maxLength) {
            return text.substr(0, maxLength) + '...';
          }
        });
        $('.shs-enabled.form-select  optgroup').attr('title', function(e, val) {
          return $(this).attr('label');
        });
        $('.shs-enabled.form-select optgroup').attr('label', function(e, val) {
          if (val.length > maxLength) {
            return val.substr(0, maxLength) + '...';
          }
        });*/


      });
    }
  }
})(jQuery, Drupal, once, drupalSettings);
